import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import Cookie from 'js-cookie';
import Router from 'next/router';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleResetPassword } from '../../redux/actions';
import SlideInModal from "../../containers/SlideInModal";
import InputList from '../InputList';
import Input from '../Input';

import { FormFooter, LoginButton, Message, } from './styles';
import { SignUpButton } from '../ForgotModal/styles';

const LoginSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'Password is too short. Minimum length is 8 characters')
    .required('Password is required'),
  newPasswordConfirmation: Yup.string()
    .min(8, 'Password is too short. Minimum length is 8 characters')
    .required('Password confirmation is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
});

const { Item } = InputList;
const { Heading, Description } = SlideInModal;

class NewPasswordModal extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    resetError: PropTypes.string,
    resetSuccess: PropTypes.bool,
    handleResetSubmit: PropTypes.func,
    resetToken: PropTypes.string,
    isValid: PropTypes.bool,
  };

  handleGoBackClick = () => {
    Router.push('/');
    Cookie.set('withLogin', 'true', { path: '/' });
  };

  render() {
    const { handleGoBackClick } = this;
    const { name, handleResetSubmit, resetError, resetSuccess, resetToken, isValid } = this.props;

    return (
      <SlideInModal name={name}>
        <Heading>
          Create new password
        </Heading>
        <Description />
        {isValid ? (
          <Formik
            initialValues={{
              newPassword: '',
              newPasswordConfirmation: '',
            }}
            validationSchema={LoginSchema}
            onSubmit={values => handleResetSubmit(values.newPassword, resetToken)}
          >
            {({ errors, touched, handleBlur, handleChange, values }) => (
              <Form>
                <InputList>
                  <Item>
                    <Input
                      htmlType="password"
                      name="newPassword"
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      value={values.newPassword}
                      hasError={errors.newPassword && touched.newPassword}
                      placeholder={errors.newPassword || 'Create a new password'}
                      floatingPlaceholder
                    />
                  </Item>
                  <Item>
                    <Input
                      htmlType="password"
                      name="newPasswordConfirmation"
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      value={values.newPasswordConfirmation}
                      hasError={errors.newPasswordConfirmation && touched.newPasswordConfirmation}
                      placeholder={errors.newPasswordConfirmation || 'Confirm a new password'}
                      floatingPlaceholder
                    />
                  </Item>
                </InputList>
                {resetError && <Message type="error">{resetError}</Message>}
                {resetSuccess && <Message type="success">Great! You will be redirected to main page in 5 seconds</Message>}
                <FormFooter>
                  <LoginButton type="submit" btnType="primary">
                    Submit
                  </LoginButton>
                  <SignUpButton type="button" onClick={handleGoBackClick}>
                    Remembered password?
                  </SignUpButton>
                </FormFooter>
              </Form>
            )}
          </Formik>
        ) : (
          <Fragment>
            <p>Looks like your link is invalid</p>
            <LoginButton type="button" btnType="primary" onClick={() => Router.push('/')}>
              Go back
            </LoginButton>
          </Fragment>
        )}

      </SlideInModal>
    )
  }
}

const mapStateToProps = state => ({
  resetError: state.user.errors.reset,
  resetSuccess: state.user.success.reset,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleResetSubmit: handleResetPassword,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewPasswordModal);
